import SnapshotInfoRow from './SnapshotInfoRow';

export default function Snapshot({
  date,
  time,
  location,
  mapUrl,
  duration,
  cost,
  accessibility,
  parking,
}) {
  return (
    <div className={'Snapshot'}>
      <h3 className={'h5 Snapshot-title headingStrong'}>Event Details</h3>

      {date && <SnapshotInfoRow label="Date" value={date} />}
      {time && <SnapshotInfoRow label="Time" value={time} />}
      {location && (
        <SnapshotInfoRow
          label="Location"
          value={
            <>
              <span>{location}</span>
              {mapUrl && (
                <a
                  className="Snapshot-mapLink"
                  href={mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View map
                </a>
              )}
            </>
          }
        />
      )}
      {duration && <SnapshotInfoRow label="Duration" value={duration} />}
      {cost && <SnapshotInfoRow label="Cost" value={cost} />}
      {accessibility && (
        <SnapshotInfoRow label="Accessibility" value={accessibility} />
      )}
      {parking && <SnapshotInfoRow label="Parking" value={parking} />}
    </div>
  );
}
